var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { SubjectLabel } from '@/models/SubjectLabel';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddSubjectLabelDialog from '@/views/SubjectLabels/AddSubjectLabelDialog';
import ErrorHandler from '@/support/ErrorHandler';
let SubjectLabels = class SubjectLabels extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'SubjectLabels';
        this.selected = [];
        this.isCreatingSubjectLabel = false;
        this.selectedSubjectLabel = null;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('subject_label.title', 1),
                plural: this.$tc('subject_label.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    editable: true,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, subjectLabel) => {
                        this.selectedSubjectLabel = subjectLabel;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new SubjectLabel(),
        };
    }
    get dialogOptions() {
        const subjectLabel = this.selectedSubjectLabel;
        return {
            title: subjectLabel.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.subjectLabel') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!subjectLabel) {
                            return;
                        }
                        subjectLabel
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedSubjectLabel = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSubjectLabel = null;
                    },
                },
            },
        };
    }
    refreshFilterStore() {
        new SubjectLabel()
            .all()
            .then((subjectLabels) => {
            const mutatedSubjectLabels = [];
            const payload = {};
            subjectLabels.forEach((subjectLabel) => {
                mutatedSubjectLabels.push({
                    value: subjectLabel.id,
                    text: subjectLabel.getFilterLabel(),
                });
            });
            payload.SubjectLabel = mutatedSubjectLabels;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
};
SubjectLabels = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddSubjectLabelDialog,
        },
    })
], SubjectLabels);
export default SubjectLabels;
